// Nav.js

import React from "react";
import "./Nav.css";
import navIcon1 from './assets/nav-icon1.svg';
import navIcon2 from './assets/twitter.svg';
import navIcon3 from './assets/nav-icon3.svg';
import KIPPRAlogo from './assets/KIPPRA-logo.png';

function Nav() {
  return (
    <div className="navbar">
      <div className="navbar-black">
        <span>
          <p>Connect with us:</p>
          <div className="social-icon">
            <a href="https://www.linkedin.com/company/kippra/mycompany/" target="_blank" rel="noopener noreferrer"><img src={navIcon1} alt="linkedin" /></a>
            <a href="https://twitter.com/KIPPRAKENYA" target="_blank" rel="noopener noreferrer"><img src={navIcon2} alt="twitter" /></a>
            <a href="https://www.instagram.com/kipprakenya/" target="_blank" rel="noopener noreferrer"><img src={navIcon3} alt="instagram" /></a>
            <a href="https://www.facebook.com/KIPPRAKENYA"  target="_blank" rel="noopener noreferrer" ><img src="https://www.transparentpng.com/thumb/facebook-logo-png/facebook-logo-clipart-hd-10.png" alt="facebook" /></a>
            <a href="https://www.youtube.com/channel/UCLmEy7_V5ZLMjsw0PR0Csig"  target="_blank" rel="noopener noreferrer" ><img src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/YouTube_full-color_icon_%282017%29.svg/1280px-YouTube_full-color_icon_%282017%29.svg.png" alt="youtube" /></a>
            <a href="https://kippra.or.ke/" target="_blank" rel="noopener noreferrer"><img src={KIPPRAlogo} alt="Kippra" /></a>
          </div>
          <a className="info-kippra" href="mailto:conference@kippra.or.ke">conference@kippra.or.ke</a>

        </span>
      </div>
    </div>
  );
}

export default Nav;